import styled from "styled-components";

/**
 * New look for the card-list sorters row (Symbol / Amount / Progress):
 * a quiet caption row instead of a tinted bar.
 */
const NewLookSortersWrapper = styled.div`
  > div {
    background: transparent;
    padding: 2px 12px 2px;
  }
  .ant-row > div > div {
    font-size: 12.5px;
    font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
  }
`;

export default NewLookSortersWrapper;
